export enum InvoiceSubscriptionEnum {
    DELETED = 'deleted',
    DRAFT = 'draft',
    OPEN = 'open',
    PAID = 'paid',
    UNCOLLECTIBLE = 'uncollectible',
    VOID = 'void',
}
